var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-modal-header card-header border-bottom"},[_vm._t("default"),_c('f-button',{attrs:{"theme":"close"},on:{"click":function($event){$event.preventDefault();return _vm.away.apply(null, arguments)}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }